import { IonCardHeader, IonCardTitle, IonCol, IonGrid, IonRow } from '@ionic/react';

import styles from '@/components/CardHeader/cardHeader.module.css';

import { mergeClassNames } from '@/utils/mergeClassNames';

export const KinematicsCardHeader = () => {
  return (
    <IonCardHeader className={styles.cardHeader}>
      <IonGrid className='ion-no-padding' fixed>
        <IonRow className={mergeClassNames('ion-align-items-center', styles['header'])}>
          <IonCol className='ion-text-center' size='4'>
            <IonCardTitle className={styles.title}>Sagittal</IonCardTitle>
          </IonCol>
          <IonCol className='ion-text-center' size='4'>
            <IonCardTitle className={styles.title}>Frontal</IonCardTitle>
          </IonCol>
          <IonCol className='ion-text-center' size='3'>
            <IonCardTitle className={styles.title}>Transversal</IonCardTitle>
          </IonCol>
        </IonRow>
      </IonGrid>
    </IonCardHeader>
  );
};
